import * as R from 'ramda';
import React from 'react';

import {translate} from 'iss/strings';
import styles from 'iss/styles/SearchableSelector.styl';
import {InputWithMultilinePaste} from 'iss/widgets/form/input/InputWithMultilinePaste';

/** A normal styled search box accepting text */
export function TextSearchBox({id, search, onChange, className}) {
  const searchText = translate('common.search');
  const update = ({target}) => onChange(target.value);
  const preventParentFormSubmit = (event) => {
    if (event.key == 'Enter') {
      event.preventDefault();
    }
  };

  return <div className={"input-group "+R.defaultTo(styles.search, className)} onKeyDown={preventParentFormSubmit}>
    <InputWithMultilinePaste id={id} className="form-control" type="text" value={search}
      onChange={update} aria-label={searchText} placeholder={searchText+"..."}/>
    <span className="input-group-btn">
      <button className="btn" type="button">
        <span className="glyphicon glyphicon-search"></span>
      </button>
    </span>
  </div>;
}



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/bootstrap/SearchBox.jsx